import { computed, inject, ref, provide } from 'vue';
const VariantContextKey = Symbol('VariantContextKey');
export const useInjectVariant = () => {
    return inject(VariantContextKey, ref(undefined));
};
export const useProviderVariant = (variant) => {
    const parentVariant = useInjectVariant();
    provide(VariantContextKey, computed(() => { var _a; return (_a = variant.value) !== null && _a !== void 0 ? _a : parentVariant.value; }));
    return variant;
};
